<template lang="">
  <div
    class="game-tr-text-area"
    :class="[{ 'position-inherit': elementTopPosition ? false : true }]"
    :style="setPosition()"
  >
    <textarea
      v-model="textAreaVal"
      :maxlength="maxLength"
      :disabled="getTextAreaData().block === true"
      @click="resetCheckStatus"
      class="tr-text-area tr-text-area-text"
      :class="[
        { 'tr-text-area-disabled': getTextAreaData().block === true },
        { 'tr-text-area-correct': getTextAreaData().inputStatus === 'correct' },
        { 'tr-text-area-wrong': getTextAreaData().inputStatus === 'incorrect' },
        { 'tr-text-area-text-aling-center': elementTextAlign === 'center' },
        { 'tr-text-area-text-aling-left': elementTextAlign === 'left' },
        { 'tr-text-area-text-aling-right': elementTextAlign === 'right' },
      ]"
      :style="'font-size:' + textAreaFontSize + ';'"
    ></textarea>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtilsV2';
export default {
  name: 'tr-text-area-v2',
  components: {},
  props: {
    config: {
      type: null,
      default: {},
    },
    trTextAreaValue: {
      type: null,
      default: '',
    },
    trTextAreaIndex: {
      type: null,
      default: 0,
    },
    offsetHorizontal: {
      type: Number,
      default: 0,
    },
    offsetVertical: {
      type: Number,
      default: 0,
    },
    textAreaWidth: {
      type: null,
      default: 100,
    },
    textAreaHeight: {
      type: null,
      default: 100,
    },
    maxLength: {
      type: null,
      default: 500,
    },
    maxLine: {
      type: null,
      default: 6,
    },
    textAreaFontSize: {
      type: null,
      default: 44,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  methods: {
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getTextAreaData() {
      if (_.isArray(this.trTextAreaValue) && _.isObject(this.trTextAreaValue[this.trTextAreaIndex])) {
        return this.trTextAreaValue[this.trTextAreaIndex];
      } else {
        return this.trTextAreaValue;
      }
    },
    setPosition() {
      return `top:${this.elementTopPosition};
              left:${this.elementLeftPosition};
              width:${this.elementWidth};
              height:${this.elementHeight};`;
    },
  },
  computed: {
    textAreaVal: {
      get() {
        if (_.isArray(this.trTextAreaValue) && _.isObject(this.trTextAreaValue[this.trTextAreaIndex])) {
          return this.trTextAreaValue[this.trTextAreaIndex].val;
        }
        return this.trTextAreaValue.val;
      },
      set(newValue) {
        if (_.isArray(this.trTextAreaValue) && _.isObject(this.trTextAreaValue[this.trTextAreaIndex])) {
          if (!this.trTextAreaValue[this.trTextAreaIndex].block) {
            this.trTextAreaValue[this.trTextAreaIndex].val = newValue;
          }
        } else {
          if (!this.trTextAreaValue.block) {
            this.trTextAreaValue.val = newValue;
          }
        }
      },
    },
    elementTopPosition() {
      return this.config && this.config.pos
        ? utils.elementTopPosition(this.config.pos.y || 0, this.offsetVertical)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config.pos
        ? utils.elementLeftPosition(this.config.pos.x || 0, this.offsetHorizontal)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.textAreaWidth);
    },
    elementHeight() {
      return utils.elementHeight(this.textAreaHeight);
    },
    elementTextAlign() {
      let align = 'center';
      if (this.config && this.config.align) {
        align = this.config.align;
      }
      return align;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/textAreaBase';
.game-tr-text-area {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  // background-color: $bacgroundColor;
  text-align: left;
  padding: 10px;
  .tr-text-area-text {
    resize: none;
    // overflow: hidden;
  }
}

.position-inherit {
  position: inherit;
}
</style>
